import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';


export default class DeleteReviewConfirmationDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    componentWillReceiveProps(props) {
        this.setState({
            open: props.open,
        });
    }

    handleClose() {
        this.setState({open: false});
    }

    handleDeleteReview() {
        this.props.handleDelete();
        this.setState({open: false});
    }

    render() {
        const actions = [
            <Button
                key={0}
                variant='text'
                onClick={() => this.handleClose()}>
                Cancel
            </Button>,
            <Button
                key={1}
                variant='text'
                color='secondary'
                onClick={() => this.handleDeleteReview()}>
                Delete
            </Button>,
        ];
        return (
            <Dialog
                onClose={this.props.onClose}
                open={this.state.open}
            >
                <DialogTitle className="dialog-title">Delete your Report?</DialogTitle>
                <DialogContent>
                    <div>
                        This cannot be undone.
                    </div>
                </DialogContent>
                <DialogActions>
                    {actions}
                </DialogActions>
            </Dialog>
        );
    }
}
